/*
 * Dropit v1.1.0
 * http://dev7studios.com/dropit
 *
 * Copyright 2012, Dev7studios
 * Free to use and abuse under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 */
(function ($) {
	$.fn.dropit = function (method) {
		var instances = [];

		var methods = {
			init: function (options) {
				this.dropit.settings = $.extend({}, this.dropit.defaults, options);

				return this.each(function () {
					var $el = $(this),
						el = this,
						settings = $.fn.dropit.settings;

					instances.push({
						elem: $el,
						settings: settings,
					});

					// Hide initial submenus
					$el
						.addClass("dropit")
						.find(">" + settings.triggerParentEl + ":has(" + settings.submenuEl + ")")
						.addClass("dropit-trigger")
						.find(settings.submenuEl)
						.addClass("dropit-submenu")
						.hide();

					// Open dropdown
					$el.on(settings.action, settings.triggerEl, function (event) {

						// Close click menu's if clicked again
						if (settings.action == "click" && $(this).parents(settings.triggerParentEl).hasClass("dropit-open")) {
							settings.beforeHide.call(this, $(this));
							$(this).parents(settings.triggerParentEl).removeClass("dropit-open").find(settings.submenuEl).hide();
							settings.afterHide.call(this, $(this));
							return false;
						}

						// Hide open menus
						settings.beforeHide.call(this, $(this));
						$(".dropit-open").removeClass("dropit-open").find(".dropit-submenu").hide();
						settings.afterHide.call(this, $(this));

						// Open this menu
						settings.beforeShow.call(this, $(this));
						$(this).parents(settings.triggerParentEl).addClass("dropit-open").find(settings.submenuEl).show();
						settings.afterShow.call(this, $(this));

						return false;
					});

					// If hover
					if (settings.action.indexOf("mouseenter") > -1) {
						$el.on("mouseleave", ".dropit-open", function () {
							var self = this;

							setTimeout(function () {
								if ($(self).is(":hover")) return;
								settings.beforeHide.call(self, $(self));
								$(self).find("> [aria-expanded]").attr("aria-expanded", false);
								$(self).removeClass("dropit-open").find(settings.submenuEl).hide();
								settings.afterHide.call(self, $(self));
							}, 250);
						});
					} else {
						// Close if outside click
						$(document).on("click", function () {
							settings.beforeHide.call(this, $el);
							$(".dropit-open").removeClass("dropit-open").find(".dropit-submenu").hide();
							settings.afterHide.call(this, $el);
						});
					}

					settings.afterLoad.call(this);

					// Keyup events: [ENTER] or [SPACEBAR]
					$el.on("keyup", function (event) {
						if ([32, 13].indexOf(event.keyCode) <= -1) return;

						const id = $(event.target).attr('id');
						const $li = $(`#${id}`).parent("li");
						const $submenu = $li.find("ul");

						$li.toggleClass("dropit-open");
						$submenu.toggle();

						return false;
					});
				});
			},
		};

		if (methods[method]) {
			return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
		} else if (typeof method === "object" || !method) {
			return methods.init.apply(this, arguments);
		} else {
			$.error('Method "' + method + '" does not exist in dropit plugin!');
		}
	};

	$.fn.dropit.defaults = {
		action: "click", // The open action for the trigger
		submenuEl: "ul", // The submenu element
		triggerEl: "a", // The trigger element
		triggerParentEl: "li", // The trigger parent element
		afterLoad: function () {}, // Triggers when plugin has loaded
		beforeShow: function () {}, // Triggers before submenu is shown
		afterShow: function () {}, // Triggers after submenu is shown
		beforeHide: function () {}, // Triggers before submenu is hidden
		afterHide: function () {}, // Triggers before submenu is hidden
	};

	$.fn.dropit.settings = {};
})(jQuery);
